import * as React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import styled from 'styled-components';

const StyledCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1rem;
`;

const StyledCard = styled.div`
  margin-bottom: 1rem;
  h3 {
    font-weight: bold;
    margin-bottom: 0;
    line-height: 1.1;
  }

  .gatsby-image-wrapper {
    object-fit: cover;
    transition: transform 0.4s;
    height: 100%;
    width: 100%;
  }

  a {
    text-decoration: none;
  }

  .thumbnail-wrapper {
    position: relative;
    overflow: hidden;
    margin-bottom: 1rem;

    &.has-link:hover {
      .gatsby-image-wrapper {
        transform: scale(1.1);
      }
    }

    &::after {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 136px;
      content: '';
      background: linear-gradient(180deg, transparent, rgba(20, 19, 44, 0.65));
    }
  }

  span {
    color: #b8bbdb;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    font-size: 13px;
    font-weight: 300;
  }
`;

const CardGrid = ({ items }) => {
  return (
    <div className="container">
      <div className="padding-x-10">
        <StyledCardGrid>
          {items.map((item, index) => (
            <Card key={index} {...item} />
          ))}
        </StyledCardGrid>
      </div>
    </div>
  );
};

const Card = ({ title, url, gatsbyImageData }) => {
  return (
    <StyledCard>
      {url ? (
        <Link className="card" to={url}>
          <div className={`thumbnail-wrapper ${url ? 'has-link' : ''}`}>
            <GatsbyImage image={gatsbyImageData} alt={title} />
          </div>
          <h3>{title}</h3>
          <span>View Project</span>
        </Link>
      ) : (
        <>
          <div className="thumbnail-wrapper">
            <GatsbyImage image={gatsbyImageData} alt={title} />
          </div>
          <h3>{title}</h3>
        </>
      )}
    </StyledCard>
  );
};

export default CardGrid;
